// src/components/Team.js
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  useColorModeValue,
  IconButton,
  Button,
  SimpleGrid,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { FaFacebookF, FaTwitter, FaPinterestP } from 'react-icons/fa';
import hashim from '../assets/hashim_png.png';
import edris from '../assets/edris.jpeg';
import mame from '../assets/mame.jpg';

// Reusable Team Member Card Component
const TeamMemberCard = ({ image, name, role, socialLinks }) => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const overlayBgColor = 'blue.800';

  return (
    <VStack
      bg={bgColor}
      borderRadius="lg"
      boxShadow="md"
      textAlign="center"
      p={6}
      spacing={4}
      align="center"
      overflow="hidden" // Prevents the blue box from spilling out
    >
      <Box position="relative" w="200px" h="200px">
        {/* The bottom blue background part */}
        <Box
          position="absolute"
          bottom="0"
          left="0"
          w="full"
          h="50%" // Covers the bottom half
          bg={overlayBgColor}
          borderTopRadius="lg" // Optional: for a slight curve
        />
        {/* The image sits on top */}
        <Image
          src={image}
          alt={name}
          borderRadius="full"
          boxSize="200px"
          objectFit="cover"
          position="relative" // Ensure it's above the blue box
          zIndex="1"
          border="4px solid"
          borderColor={bgColor}
        />
      </Box>
      <VStack spacing={1}>
        <Heading as="h3" size="md">{name}</Heading>
        <Text color="gray.500">{role}</Text>
      </VStack>
      <HStack spacing={3}>
        {socialLinks.map((social) => (
          <IconButton
            key={social.ariaLabel}
            as="a"
            href={social.href}
            aria-label={social.ariaLabel}
            icon={social.icon}
            isRound
            variant="ghost"
            colorScheme="gray"
          />
        ))}
      </HStack>
    </VStack>
  );
};

export default function Team() {
  const teamData = [
    {
      name: 'Edris Ahmed',
      role: 'Chief Executive Officer',
      image: edris,
      socialLinks: [
        { href: '#', ariaLabel: 'Facebook', icon: <FaFacebookF /> },
        { href: '#', ariaLabel: 'Twitter', icon: <FaTwitter /> },
        { href: '#', ariaLabel: 'Pinterest', icon: <FaPinterestP /> },
      ],
    },
    {
      name: 'Hashim Omer',
      role: 'Director',
      image: hashim,
      socialLinks: [
        { href: '#', ariaLabel: 'Facebook', icon: <FaFacebookF /> },
        { href: '#', ariaLabel: 'Twitter', icon: <FaTwitter /> },
        { href: '#', ariaLabel: 'Pinterest', icon: <FaPinterestP /> },
      ],
    },
    {
      name: 'Mohamed Omer',
      role: 'Civil Engineer',
      image: mame,
      socialLinks: [
        { href: '#', ariaLabel: 'Facebook', icon: <FaFacebookF /> },
        { href: '#', ariaLabel: 'Twitter', icon: <FaTwitter /> },
        { href: '#', ariaLabel: 'Pinterest', icon: <FaPinterestP /> },
      ],
    },
  ];

  return (
    <Box as="section" bg={useColorModeValue('white', 'gray.800')} py={{ base: 16, md: 24 }}>
      <Box maxW="7xl" mx="auto" px={8}>
        {/* Section Header */}
        <Flex
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          mb={12}
        >
          <VStack align={{ base: 'center', md: 'flex-start' }} textAlign={{ base: 'center', md: 'left' }} spacing={3}>
            <Text color="orange.500" fontWeight="bold">Meet Our Team</Text>
            <Heading as="h2" size="2xl" fontWeight="bold">
              Meet the Faces <br /> Behind the Structures
            </Heading>
          </VStack>
      
        </Flex>

        {/* Team Grid */}
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {teamData.map((member) => (
            <TeamMemberCard key={member.name} {...member} />
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}